import React, { useCallback, useState } from 'react';
import { Dropzone } from '@/Components/Dropzone/Dropzone';
import { useUpdateByFileForm } from './hooks/useUpdateByFileForm';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { useUpdateByFileOptions } from './hooks/useUpdateByFileOptions';
import { FormSelectInput } from '@/Components/Controls/SelectInput/FormSelectInput';
import { FormData } from './hooks/useUpdateByFileForm';
import { useLocalization } from '@/Hooks';
import { Label } from '@/Components/Controls/Label/Label';
import styles from '../../SynchModal.scss';
import { CrudExtended, IconType } from '@/Components/Controls/CrudExtended/CrudExtended';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = {
  closeModalWindow: () => void;
};

export function UpdateByFile({ closeModalWindow }: Props) {
  const {
    modalWindows: {
      mpSynchronization: {
        ModalTabs: { UpdateByFile },
        UpdateByFileTab,
      },
    },
    modules: { Synchronize },
  } = useLocalization();

  const [file, setFile] = useState<any>('');
  const { mpOptions } = useUpdateByFileOptions();
  const { onSubmit, methods, rules } = useUpdateByFileForm(file, closeModalWindow);

  const filesHandler = useCallback(
    (files: any[]) => {
      setFile(files[0]);
    },
    [methods],
  ); // filesHandler

  return (
    <div>
      <h3 className={styles.title}>{Synchronize}</h3>
      <p className={styles.text}> {UpdateByFile.text} </p>

      <form className={styles.form}>
        <div className={styles.formItemWrapper}>
          <Label nowrap text={UpdateByFileTab.form.mpAccountLabel} />
          <FormSelectInput<FormData>
            register={methods.register}
            rules={{ ...rules.required }}
            error={methods.formState.errors}
            name={'mpAccountId'}
            options={mpOptions}
            needClearButton={false}
          />
        </div>

        {file ? (
          <div className={styles.uploadedFile}>
            <span>{file.name}</span>
            <CrudExtended
              iconItems={[
                {
                  onClick: () => setFile(null),
                  icon: IconType.Delete,
                  active: true,
                },
              ]}
            />
          </div>
        ) : (
          <Dropzone filesHandler={filesHandler} btnText={UpdateByFileTab.dropzoneText} accept={'.txt, .csv'} />
        )}

        <ButtonsWrapper>
          <Button
            autoFocus={true}
            className={styles.wideButton}
            text={UpdateByFileTab.updateOrdersButton}
            theme={BUTTON_THEMES.SUCCESS}
            disabled={!methods.formState.isValid || !file}
            onClick={onSubmit}
          />
        </ButtonsWrapper>
      </form>
    </div>
  );
}
